import React from 'react';
import styled from 'styled-components';

export const DEFAULT_ICON_SLOT_WIDTH = '1.75rem';

const CellContainer = styled.div`
  display: flex;
  align-items: center;
`;

const IconSlot = styled.span<{ $width: string }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  min-width: ${({ $width }) => $width};
`;

type IconSlotCellProps = {
  children: React.ReactNode;
  className?: string;
  icon: React.ReactNode;
  iconSlotWidth?: string;
  isIconVisible: boolean;
};

/**
 * Table cell content that reserves a fixed-width leading slot for an optional
 * icon. Pair with <IconSlotColumnHeader /> (using the same width) to keep the
 * column header aligned with the values.
 */
export function IconSlotCell({
  children,
  className,
  icon,
  iconSlotWidth = DEFAULT_ICON_SLOT_WIDTH,
  isIconVisible,
}: IconSlotCellProps) {
  return (
    <CellContainer className={className}>
      <IconSlot $width={iconSlotWidth}>
        {isIconVisible ? icon : undefined}
      </IconSlot>
      {children}
    </CellContainer>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderSpacer = styled.span<{ $width: string }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  min-width: ${({ $width }) => $width};
`;

type IconSlotColumnHeaderProps = {
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
  iconSlotWidth?: string;
};

/**
 * Column header for a column whose cells render <IconSlotCell />. Reserves the
 * same leading space as the icon slot so the header aligns with the values.
 */
export function IconSlotColumnHeader({
  children,
  className,
  icon,
  iconSlotWidth = DEFAULT_ICON_SLOT_WIDTH,
}: IconSlotColumnHeaderProps) {
  return (
    <HeaderContainer className={className}>
      <HeaderSpacer $width={iconSlotWidth}>{icon}</HeaderSpacer>
      {children}
    </HeaderContainer>
  );
}
